var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSelf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 42C28.6644 42 28.3315 41.8696 28.0738 41.6116L16.9732 30.3796C10.3423 23.6703 10.3423 12.7508 16.9732 6.04147C20.1866 2.79005 24.4577 1 29 1C33.5423 1 37.8134 2.79005 41.0268 6.04147C47.6577 12.7508 47.6577 23.6676 41.0268 30.3796L29.9262 41.6116C29.6711 41.8696 29.3356 42 29 42Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 42C28.6644 42 28.3315 41.8696 28.0738 41.6116L16.9732 30.3796C10.3423 23.6703 10.3423 12.7508 16.9732 6.04147C20.1866 2.79005 24.4577 1 29 1C33.5423 1 37.8134 2.79005 41.0268 6.04147C47.6577 12.7508 47.6577 23.6676 41.0268 30.3796L29.9262 41.6116C29.6711 41.8696 29.3356 42 29 42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4432 9.09602C29.1602 8.96799 28.8398 8.96799 28.5568 9.09602L20.6818 12.6585C20.2682 12.8456 20 13.275 20 13.75C20 14.225 20.2682 14.6544 20.6818 14.8415L23.6567 16.1873C23.7648 16.0579 23.9004 15.9525 24.0568 15.8818L28.5568 13.846C29.1279 13.5877 29.7893 13.8669 30.034 14.4697C30.2788 15.0726 30.0142 15.7707 29.4432 16.029L26.375 17.417L28.5568 18.404C28.8398 18.532 29.1602 18.532 29.4432 18.404L37.3182 14.8415C37.7318 14.6544 38 14.225 38 13.75C38 13.275 37.7318 12.8456 37.3182 12.6585L29.4432 9.09602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4738 17.7836L23.375 18.6437V23.5144C22.9894 23.4221 22.5954 23.353 22.1945 23.3087C21.6661 23.2502 21.2484 22.8093 21.193 22.2515C21.148 21.7987 21.125 21.3394 21.125 20.8748C21.125 19.8102 21.2458 18.7749 21.4738 17.7836Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2125 26.3049C27.4555 25.5216 26.5831 24.8631 25.625 24.3605V19.6616L27.6705 20.5869C28.5195 20.971 29.4805 20.971 30.3295 20.5869L36.5262 17.7836C36.7542 18.7749 36.875 19.8102 36.875 20.8748C36.875 21.3394 36.852 21.7987 36.807 22.2515C36.7516 22.8093 36.3339 23.2502 35.8055 23.3087C33.4735 23.5667 31.3764 24.6607 29.7876 26.3049C29.3501 26.7576 28.6499 26.7576 28.2125 26.3049Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28C25.1213 28 25.625 27.4683 25.625 26.8125V24.3605C24.9178 23.9894 24.1638 23.7033 23.375 23.5144V26.8125C23.375 27.4683 23.8787 28 24.5 28Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8524",
    x: 10.5,
    y: 0.5,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSelf);
export default __webpack_public_path__ + "static/media/marker_self.46b016205071b7ed1edfc2ac24c8bf7e.svg";
export { ForwardRef as ReactComponent };